document.addEventListener('DOMContentLoaded', () => {
  const ctaSwiper = () => {
    const swiperInstance = new Swiper('.cta-slider', {
      slidesPerView: 1.2,
      spaceBetween: 9,
      watchOverflow: true,
      centeredSlides: true,
      centeredSlidesBounds: true,
      navigation: {
        nextEl: '.press-swiper__next',
        prevEl: '.press-swiper__prev'
      },
      breakpoints: {
        1130: {
          slidesPerView: 3,
          centeredSlides: false
        },
        768: {
          slidesPerView: 2.2,
          centeredSlides: false
        }
      },
    });
  };

  document.addEventListener('shopify:section:load', () => {
    ctaSwiper();
  });

  ctaSwiper();
});